import React from 'react';

export interface SpinnerProps {
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

const Spinner: React.FC<SpinnerProps> = ({
  size = 'medium',
  className = '',
}) => {
  const cls = ['wg-spinner', `wg-spinner--${size}`, className]
    .filter(Boolean)
    .join(' ');
  return <div className={cls} role="status" aria-live="polite" />;
};

export default Spinner;
